export function getSuccessMsg(messageData) {
  let msg = '';

  if (messageData.userRegistered === true) {
    msg = 'Merci de valider votre email.';
  } else if (messageData.userConfirmed === true) {
    msg = 'Votre compte est activé, vous pouvez désormais vous connecter.';
  } else if (messageData.userPatched === true) {
    msg = 'Votre compte a bien été mis à jour.';
  } else if (messageData.reservationDeleted === true) {
    msg = 'La réservation a bien été annulée.';
  } else if (messageData.reservationPatched === true) {
    msg = 'La réservation a bien été modifiée.';
  } else if (messageData.reservationCreated === true) {
    msg = 'La réservation a bien été créée.';
  }

  return msg;
}

export function getErrorMsg(messageData) {
  let msg = '';

  if (messageData.errors) {
    // login / inscription
    if (messageData.errors.email === false) {
      msg = 'L\'email ne correspond à aucun utilisateur.';
    } else if (messageData.errors.password === false) {
      msg = 'Le mot de passe est invalide.';
    } else if (messageData.errors.actif === false) {
      msg = 'Votre compte n\'est pas actif.';
    } else if (messageData.errors.userConfirmed === false) {
      msg = 'Une erreur est survenue lors de l\'activation de votre compte, ou votre compte est déjà activé.';
    } else if (messageData.errors.emailAlreadyUse) {
      msg = 'L\'email est déjà utilisé.'
    }

    // reservation
    else if (messageData.errors.invalidReservation) {
      msg = 'La réservation est invalide.';
    } else if (messageData.errors.notYoursReservation) {
      msg = 'Cette réservation ne vous appartient pas.';
    } else if (messageData.errors.notCancellable) {
      msg = 'Cette réservation ne peut plus être annulée.';
    } else if (messageData.errors.notEditable) {
      msg = 'Cette réservation ne peut plus être modifiée.';
    } else if (messageData.errors.timeSlotConflict) {
      msg = 'Une réservation est déjà présente sur ce créneau horaire.';
    } else if (messageData.errors.users) {
      messageData.errors.users.forEach(user => {
        if (user.errors.alreadyBookDay) {
          msg += (user.isMe ? 'Vous avez' : `${user.prenom} a`) + ` déjà ${user.errors.alreadyBookDay} créneau(x) de réservé ce jour.`;
        } else if (user.errors.subscriptionExpires) {
          msg += (user.isMe ? `Votre date d'abonnement` : `La date d'abonnement de ${user.prenom}`) + ` a expiré.`;
        } else if (user.errors.noCredit) {
          msg += (user.isMe ? `Votre crédit` : `Le crédit de ${user.prenom}`) + ` est épuisé.`;
        } else if (user.errors.noInfo) {
          msg += (user.isMe ? `Vous devez remplir vos` : `${user.prenom} doit remplir ses`) + ` coordonnées postales et téléphoniques.`;
        }

        msg += ' ';
      });
    } else if(messageData.errors.invalidHours) {
      const horaire = messageData.errors.invalidHours;
      msg += `Votre réservation ne correspond pas à la plage horaire ${horaire.debut} / ${horaire.fin}.`;
    }
  }

  // field error
  if (messageData.fieldErrors) {
    for (const [field, type] of Object.entries(messageData.fieldErrors)) {
      msg = 'Le champ \'' + getFieldName(field) + '\' est ' + getFieldErrorType(type) + '. ';
    }
  }

  if( !msg ) {
    msg = 'Une erreur inconnue est survenue.';
  }

  return msg;
};

function getFieldErrorType(type) {
  let errorType = 'obligatoire';

  if (type === 'regexp' || type === 'minLength') {
    errorType = 'invalide';
  }

  if (type.indexOf('equal') === 0) {
    errorType = 'différent de \'' + getFieldName(type.split('|')[1]) + '\'';
  }

  return errorType;
}

function getFieldName(field) {
  const rows = [
    { key: 'prenom', label: 'prénom' },
    { key: 'pass', label: 'mot de passe' },
    { key: 'passConfirm', label: 'confirmation mot de passe' },
    { key: 'nbCreneau', label: 'nombre de créneau' },
    { key: 'dateNaissance', label: 'date de naissance' },
    { key: 'clients', label: 'nom de mon adversaire' }
  ];

  const findRow = rows.find(row => row.key === field);

  return findRow ? findRow.label : field;
}
